module.exports = __webpack_public_path__ + "static/img/Excellent.fa37420c.png";